import getHelper from '../../../services/getHelper';

export default getHelper('/job-applications/:id');
